/*
 *  Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.0.0
 */

import { select } from 'redux-saga/effects';

import { AuthMenuEnum } from '../../../../pages/PageAuth/constants/authConstants';
import { makeSelectAuthMenu } from '../../../../pages/PageAuth/selectors/authSelectors';
import { IAuthMenu } from '../../../../pages/PageAuth/types/authTypes';
import { AccessComponentKeyEnum } from '../../constants/guard/guardConstants';
import {
    MenuAccountKeys,
    MenuCollectiveProductKeys,
    MenuHistoryInquiryKeys,
    MenuHistoryOrderKeys,
    MenuMainKeys,
    MenuOffersKeys,
    MenuServiceSubscriberKeys,
} from '../../types/conditionTypes';

export function* isMenuEnabledConditionSaga(componentKey: AccessComponentKeyEnum) {
    const menu: IAuthMenu = yield select(makeSelectAuthMenu());

    if (MenuAccountKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.ACCOUNTS];
    }

    if (MenuServiceSubscriberKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.SUBSCRIBERS_MOBILE];
    }

    if (MenuHistoryOrderKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.ORDERS];
    }

    if (MenuHistoryInquiryKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.INQUIRIES];
    }

    if (MenuOffersKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.CAMPAIGNS];
    }

    if (MenuMainKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.MAIN];
    }

    if (MenuCollectiveProductKeys.includes(componentKey)) {
        return menu[AuthMenuEnum.COLLECTIVE_PRODUCT];
    }

    return true;
}
